import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { type DevInfoType, DevInfoTypes } from '@atlassian/jira-development-board-common';

import type { ReviewState } from '@atlassian/jira-development-details-loader';
import type {
	JiraPullRequestState,
	JiraReviewState,
} from '@atlassian/jira-relay/src/__generated__/development_softwareReleasesVersionDetailIssueList.graphql';

export const mapPullRequestStateToIconColour = (state: JiraPullRequestState) => {
	switch (state) {
		case 'MERGED':
			return token('color.icon.success', colors.G300);
		case 'DECLINED':
			return token('color.icon.danger', colors.R400);
		default:
			return token('color.icon', colors.N500);
	}
};

export const mapReviewStateToIconColour = (state: JiraReviewState) => {
	switch (state) {
		case 'REVIEW':
			return token('color.icon', colors.N500);
		case 'APPROVAL':
			return token('color.icon', colors.N500);
		case 'SUMMARIZE':
			return token('color.icon', colors.N500);
		case 'REJECTED':
			return token('color.icon.danger', colors.R400);
		case 'CLOSED':
			return token('color.icon.success', colors.G300);
		case 'DRAFT':
			return token('color.icon', colors.N500);
		case 'DEAD':
			return token('color.icon.danger', colors.R400);
		case 'UNKNOWN':
			return token('color.icon.danger', colors.R400);
		default:
			return token('color.icon', colors.N500);
	}
};

export const toReviewState = (state: JiraReviewState): ReviewState => {
	switch (state) {
		case 'REVIEW':
		case 'APPROVAL':
		case 'SUMMARIZE':
		case 'REJECTED':
		case 'CLOSED':
		case 'DRAFT':
		case 'DEAD':
			return state;
		default:
			return 'UNKNOWN';
	}
};

export const toDevInfoType = (state: JiraPullRequestState): DevInfoType => {
	switch (state) {
		case 'DECLINED':
			return DevInfoTypes.DECLINED;
		case 'MERGED':
			return DevInfoTypes.MERGED;
		default:
			return DevInfoTypes.PULLREQUEST;
	}
};
